import { render, staticRenderFns } from "./applyList.vue?vue&type=template&id=b71847ca&scoped=true&"
import script from "./applyList.vue?vue&type=script&lang=js&"
export * from "./applyList.vue?vue&type=script&lang=js&"
import style0 from "./applyList.vue?vue&type=style&index=0&id=b71847ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71847ca",
  null
  
)

export default component.exports